export const projects = [
  {
    img: "https://user-images.githubusercontent.com/95956045/170425540-7cb29a88-a831-4018-ba39-0ac9988d0881.png",
    title: "Fashio Ecommerce clothing ",
    des: "A Fashion ecommerce website",
    demo: "",
    live: "https://fashio-frontend.vercel.app/",
    gitHub: "https://github.com/DhruvBhawsar/fashio-ecommerce",
    technologies: [
      "HTML",
      "CSS",
      "React",
      "React-redux",
      "node",
      "express",
      "mongodb",
      "Javascript",
    ],
  },
  {
    img: "https://user-images.githubusercontent.com/95956045/158768227-8cdb20d4-1b27-477c-9bb1-8f0d94999d80.png",
    title: "Revv Rental Cars",
    des: "A website to rent cars on monthly or daily basis",
    demo: "",
    live: "https://revv-rentals-clone-2-0.vercel.app/",
    gitHub: "https://github.com/DhruvBhawsar/Revv-Rentals-clone-2.0",
    technologies: ["HTML", "CSS", "mongodb", "Javascript"],
  },
  {
    img: "https://user-images.githubusercontent.com/95956045/158765528-b31185df-efe9-4e47-8248-7410ab9df48f.png",
    title: "American Eagle",
    des: "A E-Commerce website where you can purchase the clothes and daily fashion things from your home.",
    demo: "",
    live: "https://american-eagle-web-clone.vercel.app/",
    gitHub: "https://github.com/jeevan243/American-Eagle-Web",
    technologies: ["HTML", "CSS", "Javascript"],
  },
  {
    img: "https://user-images.githubusercontent.com/95956045/159113538-46665671-633d-4db8-9423-4f91deb8c646.png",
    title: "Mini Youtube",
    des: "A mini youtube, you can search the videos of your interest.",
    demo: "",
    live: "https://youtube-clone-mini.vercel.app/",
    gitHub: "https://github.com/DhruvBhawsar/Youtube-Clone-mini-",
    technologies: ["HTML", "CSS", "Javascript"],
  },
];
